/* Gold & Richie — product page
   Variant selection, gallery, zoom, sticky purchase bar. */

(function () {
  'use strict';

  var GR = window.GR;
  var root = document.querySelector('[data-gr-product]');
  if (!root || !GR) return;

  var dataEl = root.querySelector('[data-gr-variants]');
  var variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (error) {
    variants = [];
  }

  /* --------------------------------------------------------- variant picker */

  var picker = root.querySelector('[data-gr-variant-picker]');

  function selectedOptions() {
    if (!picker) return [];
    var inputs = picker.querySelectorAll('[data-gr-option-input]:checked');
    return Array.prototype.map.call(inputs, function (input) { return input.value; });
  }

  function findVariant(options) {
    return variants.find(function (variant) {
      return options.every(function (value, index) {
        return variant.options[index] === value;
      });
    });
  }

  // Grey out combinations that do not exist, so a shopper never picks a
  // dead end and then discovers it at the button.
  function updateAvailability() {
    if (!picker) return;

    var chosen = selectedOptions();

    picker.querySelectorAll('fieldset[data-option-position]').forEach(function (fieldset, fieldIndex) {
      fieldset.querySelectorAll('[data-gr-option-input]').forEach(function (input) {
        var trial = chosen.slice();
        trial[fieldIndex] = input.value;

        var match = variants.find(function (variant) {
          return trial.every(function (value, index) {
            // Only compare the options decided so far.
            return index > fieldIndex ? true : variant.options[index] === value;
          });
        });

        var label = input.nextElementSibling;
        if (!label) return;

        if (!match) {
          label.dataset.unavailable = 'true';
        } else {
          label.dataset.unavailable = match.available ? 'false' : 'soldout';
        }
      });
    });
  }

  function updatePrice(variant) {
    var block = root.querySelector('[data-gr-price-block]');
    if (!block) return;

    var now = block.querySelector('[data-gr-price-now]');
    var was = block.querySelector('[data-gr-price-was]');
    var badge = block.querySelector('[data-gr-save-badge]');
    var from = block.querySelector('.gr-pdp__from');
    var onSale = variant.compare_at_price > variant.price;

    if (from) from.remove();

    if (now) {
      now.textContent = GR.formatMoney(variant.price);
      now.classList.toggle('is-sale', onSale);
    }

    if (was) {
      if (onSale) was.textContent = GR.formatMoney(variant.compare_at_price);
      was.hidden = !onSale;
    }

    if (badge) {
      if (onSale) {
        var template = badge.getAttribute('data-gr-save-template') || 'Save [amount]';
        badge.textContent = template.replace(
          '[amount]',
          GR.formatMoney(variant.compare_at_price - variant.price)
        );
      }
      badge.hidden = !onSale;
    }

    var sticky = root.querySelector('[data-gr-sticky-price]');
    if (sticky) sticky.textContent = GR.formatMoney(variant.price);
  }

  function updateButton(variant) {
    var button = root.querySelector('[data-gr-add-button]');
    var label = root.querySelector('[data-gr-add-label]');
    var idInput = root.querySelector('[data-gr-variant-id]');
    var stickyBtn = root.querySelector('[data-gr-sticky-add]');

    if (idInput) {
      idInput.value = variant ? variant.id : '';
      idInput.disabled = !variant || !variant.available;
    }

    var available = variant && variant.available;
    var text = !variant ? GR.strings.unavailable : (available ? GR.strings.addToCart : GR.strings.soldOut);

    if (button) button.disabled = !available;
    if (label) label.textContent = text;
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.textContent = text;
    }
  }

  function updateSku(variant) {
    var sku = root.querySelector('[data-gr-sku] span');
    if (sku && variant && variant.sku) sku.textContent = variant.sku;
  }

  function updateLegend(variant) {
    if (!picker || !variant) return;
    picker.querySelectorAll('[data-gr-option-value]').forEach(function (el, index) {
      el.textContent = variant.options[index];
    });
  }

  function showVariantMedia(variant) {
    if (!variant || !variant.featured_media) return;
    goToMedia(String(variant.featured_media.id));
  }

  if (picker) {
    picker.addEventListener('change', function (event) {
      if (!event.target.matches('[data-gr-option-input]')) return;

      var variant = findVariant(selectedOptions());

      updateAvailability();
      updateLegend(variant);
      updateButton(variant);

      if (variant) {
        updatePrice(variant);
        updateSku(variant);
        showVariantMedia(variant);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });

    updateAvailability();
  }

  // Take ownership of the `id` field, which ships disabled so it cannot submit
  // alongside the noscript select.
  updateButton(findVariant(selectedOptions()));

  /* ---------------------------------------------------------------- gallery */

  var stage = root.querySelector('[data-gr-gallery-stage]');

  function goToMedia(mediaId) {
    if (!stage) return;

    var slide = stage.querySelector('[data-gr-slide="' + mediaId + '"]');
    if (!slide) return;

    // Desktop swaps slides; mobile is a scroller, so scroll it into view.
    if (window.matchMedia('(min-width: 990px)').matches) {
      stage.querySelectorAll('[data-gr-slide]').forEach(function (el) {
        el.dataset.inactive = el === slide ? 'false' : 'true';
      });
    } else {
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    root.querySelectorAll('[data-gr-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-selected', thumb.getAttribute('data-gr-thumb') === mediaId ? 'true' : 'false');
    });
    root.querySelectorAll('[data-gr-dot]').forEach(function (dot) {
      dot.dataset.active = dot.getAttribute('data-gr-dot') === mediaId ? 'true' : 'false';
    });

    // Pause any video that just left the stage.
    stage.querySelectorAll('video').forEach(function (video) {
      if (!video.closest('[data-gr-slide]').contains(slide)) video.pause();
    });
  }

  root.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gr-thumb]');
    if (thumb) {
      goToMedia(thumb.getAttribute('data-gr-thumb'));
      return;
    }

    var dot = event.target.closest('[data-gr-dot]');
    if (dot) goToMedia(dot.getAttribute('data-gr-dot'));
  });

  // Keyboard support for the thumbnail tablist.
  root.addEventListener('keydown', function (event) {
    var thumb = event.target.closest('[data-gr-thumb]');
    if (!thumb) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gr-thumb]'));
    var index = thumbs.indexOf(thumb);
    var next;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = thumbs[index + 1] || thumbs[0];
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = thumbs[index - 1] || thumbs[thumbs.length - 1];
    if (!next) return;

    event.preventDefault();
    next.focus();
    goToMedia(next.getAttribute('data-gr-thumb'));
  });

  // Track which slide is showing while the mobile gallery is swiped.
  if (stage && 'IntersectionObserver' in window) {
    var slideObserver = new IntersectionObserver(function (entries) {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.6) return;
        var id = entry.target.getAttribute('data-gr-slide');
        root.querySelectorAll('[data-gr-dot]').forEach(function (dot) {
          dot.dataset.active = dot.getAttribute('data-gr-dot') === id ? 'true' : 'false';
        });
      });
    }, { root: stage, threshold: 0.6 });

    stage.querySelectorAll('[data-gr-slide]').forEach(function (slide) { slideObserver.observe(slide); });
  }

  /* ------------------------------------------------------------------- zoom */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-gr-zoom]');
    if (!trigger) return;

    var src = trigger.getAttribute('data-gr-zoom');
    var lightbox = document.createElement('div');
    lightbox.className = 'gr-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Enlarged image');
    lightbox.innerHTML =
      '<button type="button" class="gr-lightbox__close" aria-label="Close">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round">' +
        '<path d="M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5"/></svg>' +
      '</button>' +
      '<img src="' + src + '" alt="">';

    document.body.appendChild(lightbox);
    document.body.dataset.scrollLocked = 'true';

    window.requestAnimationFrame(function () { lightbox.dataset.open = 'true'; });

    var closeBtn = lightbox.querySelector('.gr-lightbox__close');
    closeBtn.focus();

    function close() {
      lightbox.dataset.open = 'false';
      delete document.body.dataset.scrollLocked;
      window.setTimeout(function () { lightbox.remove(); }, 240);
      trigger.focus();
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      // The lightbox holds one control, so keep Tab inside it.
      if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); }
    }

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.closest('.gr-lightbox__close')) close();
    });
    document.addEventListener('keydown', onKey);
  });

  /* ------------------------------------------------------- sticky buy bar */

  var sticky = root.querySelector('[data-gr-sticky-buy]');
  var buyBlock = root.querySelector('.gr-pdp__buy');

  if (sticky && buyBlock && 'IntersectionObserver' in window) {
    var buyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.hidden = entry.isIntersecting;
      });
    }, { rootMargin: '-80px 0px 0px 0px' });

    buyObserver.observe(buyBlock);
  }
})();
